import { useEffect, useState } from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import api from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Download } from "lucide-react";
import { formatDateTime } from "@/lib/format";

export default function Subscribers() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");

  const load = async () => {
    try { const { data } = await api.get("/subscribers"); setList(data); }
    catch { toast.error("Failed to load subscribers"); }
  };
  useEffect(() => { load(); }, []);

  const del = async (s) => {
    if (!confirm(`Remove ${s.email}?`)) return;
    try { await api.delete(`/subscribers/${s.id}`); toast.success("Removed"); load(); }
    catch { toast.error("Delete failed"); }
  };

  const filtered = list.filter((s) => s.email.toLowerCase().includes(q.toLowerCase()));

  const exportCsv = () => {
    const rows = [["Email", "Subscribed at"], ...filtered.map((s) => [s.email, s.subscribed_at])];
    const csv = rows.map((r) => r.map((c) => `"${(c || "").toString().replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `bdtt-subscribers-${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <AdminLayout title="Subscribers">
      <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by email…" className="email-input pl-4 max-w-sm" data-testid="subscribers-search" />
        <div className="flex items-center gap-3">
          <span className="text-sm text-[color:var(--ivory-muted)]">{filtered.length} of {list.length}</span>
          <button onClick={exportCsv} className="pill border border-white/15 text-white inline-flex items-center gap-2 text-sm" data-testid="subscribers-export">
            <Download className="w-4 h-4" /> Export CSV
          </button>
        </div>
      </div>

      <div className="overflow-x-auto rounded-2xl border border-white/10 bg-white/[0.02]">
        <table className="w-full text-sm" data-testid="subscribers-table">
          <thead className="bg-white/[0.03] text-[color:var(--ivory-muted)] text-xs uppercase tracking-[0.15em]">
            <tr><th className="px-4 py-3 text-left">Email</th><th className="px-4 py-3 text-left">Subscribed</th><th /></tr>
          </thead>
          <tbody>
            {filtered.map((s) => (
              <tr key={s.id} className="border-t border-white/5 hover:bg-white/[0.02]" data-testid={`subscriber-row-${s.id}`}>
                <td className="px-4 py-3 font-medium">{s.email}</td>
                <td className="px-4 py-3 text-[color:var(--ivory-muted)]">{formatDateTime(s.subscribed_at)}</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => del(s)} className="p-2 hover:text-[color:var(--bd-red-bright)] text-[color:var(--ivory-muted)]">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan="3" className="p-12 text-center text-[color:var(--ivory-muted)]">No subscribers.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
